module.exports = __webpack_public_path__ + "static/media/Synergy-Security-Solutions.82f0cd2c.png";